**Index performance** is shown with a starting value of 100. Performance before the
index live date is the hypothetical back-tested performance and is shown in black, whereas
live performance is shown in red.
